import Table from 'react-bootstrap/Table';
import { useTable, useSortBy } from 'react-table';
import { useMemo } from 'react';
import Button from 'react-bootstrap/Button';

function AdminAdministratorTable({
  adminList,
  onDelete,
  chosenAdminId,
  chosenAdmin,
  onEdit,
}) {
  const data = useMemo(() => adminList, [adminList]);

  const columns = useMemo(
    () => [
      {
        Header: 'Namn',
        accessor: 'name',
        className: 'p-3',
        style: { width: '45%' },
        Cell: ({ cell: { value } }) => (
          <div className='d-flex gap-1'>
            <b>{value ? value : 'Ej angett'}</b>
          </div>
        ),
      },
      {
        Header: 'E-post',
        accessor: 'email',
        className: 'p-3',
        style: { width: '45%' },
        Cell: ({ cell: { value } }) => (
          <div className='d-flex gap-1'>{value ? value : 'Ej angett'}</div>
        ),
      },
      {
        Header: '',
        accessor: 'id',
        className: 'p-3',
        Cell: ({ cell: { value } }) => (
          <div
            className='d-flex gap-2 justify-content-end'
            role='button'
            onClick={() => {
              chosenAdminId(value);
              onDelete();
            }}
          >
            <span className='material-symbols-outlined'>delete</span>
            <span>Radera</span>
          </div>
        ),
      },
      {
        Header: '',
        accessor: 'edit',
        className: 'p-3 d-flex justify-content-end',
        Cell: (props) => (
          <Button
            variant='outline-primary'
            className='py-0 px-3'
            onClick={() => {
              chosenAdmin(props.row.original);
              onEdit();
            }}
          >
            Redigera
          </Button>
        ),
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
      },
      useSortBy
    );

  return (
    <Table
      {...getTableProps()}
      style={{
        borderCollapse: 'separate',
        borderSpacing: '0 0.5rem',
        width: '100%',
      }}
      className='table-borderless'
    >
      <thead className='bg-divider'>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render('Header')}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr
              {...row.getRowProps()}
              className='bg-white'
              style={{ borderStyle: 'none' }}
            >
              {row.cells.map((cell) => {
                return (
                  <td
                    {...cell.getCellProps()}
                    className={cell.column.className}
                    style={cell.column.style}
                  >
                    {cell.render('Cell')}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}

export default AdminAdministratorTable;
